(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-brand-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeHsHeroVideo = (root = document) => {
    root.querySelectorAll('[data-hs-hero]').forEach((hero) => {
      if (hero.dataset.hsVideoReady === 'true') return;

      const shell = hero.querySelector('[data-hs-hero-video-shell]');
      const video = shell?.querySelector('video');
      const control = hero.querySelector('[data-hs-hero-video-control]');

      if (!shell || !video || !control) return;

      hero.dataset.hsVideoReady = 'true';

      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const smallScreen = window.matchMedia('(max-width: 749px)').matches;
      const mobileVideoAllowed = hero.dataset.hsVideoMobile === 'true';
      const slowConnection = ['slow-2g', '2g'].includes(connection?.effectiveType);

      if (reducedMotion || connection?.saveData || slowConnection || (smallScreen && !mobileVideoAllowed)) return;

      let manuallyPaused = false;

      const updateControl = () => {
        const paused = video.paused;
        control.dataset.state = paused ? 'paused' : 'playing';
        control.setAttribute('aria-label', paused ? control.dataset.playLabel : control.dataset.pauseLabel);
      };

      const playVideo = () => {
        if (manuallyPaused || document.hidden) return;
        shell.hidden = false;
        video.play()
          .then(() => {
            control.hidden = false;
            updateControl();
          })
          .catch(() => {
            shell.hidden = true;
            control.hidden = true;
          });
      };

      const pauseVideo = () => {
        video.pause();
        updateControl();
      };

      control.addEventListener('click', () => {
        if (video.paused) {
          manuallyPaused = false;
          playVideo();
        } else {
          manuallyPaused = true;
          pauseVideo();
        }
      });

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          playVideo();
        } else {
          video.pause();
        }
      }, { threshold: 0.15 });

      observer.observe(hero);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          video.pause();
        } else {
          playVideo();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHsHeroVideo());
  } else {
    initializeHsHeroVideo();
  }

  document.addEventListener('shopify:section:load', (event) => initializeHsHeroVideo(event.target));

  } catch(e) { console.error(e); }
})();
})();
